__turbopack_context__.v({
  "black": "RuPKDG_black",
  "copyright": "RuPKDG_copyright",
  "footer": "RuPKDG_footer",
  "footerText": "RuPKDG_footerText",
  "light": "RuPKDG_light",
  "link": "RuPKDG_link",
  "smsDisclaimer": "RuPKDG_smsDisclaimer",
  "socialNetworks": "RuPKDG_socialNetworks",
  "socialNetworksWrapper": "RuPKDG_socialNetworksWrapper",
  "white": "RuPKDG_white",
});
